import * as React from "react";
import { PureStringField } from "./Pure/PureStringField";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react";
import { BaseFieldProps } from './types';
import FileManager from '../FileManager/FileManager';
import { FileTypes } from "app/services/file-manager";
import { validateUrl } from "app/shared/functions";
import { getFilePath } from "app/utils/service";

interface VideoFieldState {
    fileManagerActive: boolean;
}

// Kendisine gelen Property ismine ve değerine göre Video render eder.
export default class VideoField extends React.Component<BaseFieldProps, VideoFieldState> {

    constructor(props: BaseFieldProps) {
        super(props);
        this.state = {
            fileManagerActive: false
        };
    }

    render() {
        if (this.props.property.conditionalHide && this.props.property.conditionalHide(this.props)) return null;
        const file = this.props.value;
        const splitted = file?.split(".");
        const videoSource = validateUrl(file) ? file : (getFilePath() + file + (!splitted || splitted[splitted?.length - 1] !== "mp4" ?
        "?width=200&height=200" : ""));
        return (
            <React.Fragment>
                <FileManager
                    activeFile={this.props.value}
                    onSelectedFile={(file) => {
                        this.props.onChange(getFilePath() + file.fileName)
                    }}
                    fileType={FileTypes.Video}
                    show={this.state.fileManagerActive}
                    onDismiss={() => {
                        this.setState({
                            fileManagerActive: false
                        })
                    }}
                />
                <PureStringField
                    label={this.props.property.name}
                    text={this.props.property.text as string}
                    description={this.props.property.description as string}
                    value={this.props.value}
                    onChange={value => this.props.onChange(value)}
                    videoSource={this.props.value ? videoSource : ""}
                    className="video-field"
                    customRender={() => {
                        return (
                            <div style={{ marginLeft: "auto" }} className="row">
                                <DefaultButton
                                    className="custom-button"
                                    text="Görüntüle"
                                    style={{ marginTop: 2.5 }}
                                    disabled={!this.props.value}
                                    onClick={() => {
                                        window.open(videoSource, "_blank")
                                    }}
                                />
                                <PrimaryButton
                                    className="custom-button m-left-auto"
                                    text="Video Seç"
                                    style={{ marginTop: 2.5 }}
                                    onClick={() => {
                                        this.setState({
                                            fileManagerActive: true
                                        }, () => {
                                            document.querySelector(".external-panel")?.classList.add("fade");
                                        });
                                    }}
                                />
                            </div>
                        )
                    }}
                />
            </React.Fragment>
        );
    }
}
